import PropTypes from 'prop-types';
import checkUrl from './check.svg';

export const YOU_CHECK_ICON_URL = checkUrl;

export const YouCheckIcon = ({ size = 20, alt = '' }) => (
  <img
    src={checkUrl}
    alt={alt}
    width={size}
    height={size}
    data-testid="you-check-icon"
  />
);

YouCheckIcon.propTypes = {
  size: PropTypes.number,
  alt: PropTypes.string,
};

export default YouCheckIcon;
